/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Roadmap_FailedInputs */

const en_roadmap_failed = /** @type {(inputs: Roadmap_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not export the roadmap. Try again.`)
};

const de_roadmap_failed = /** @type {(inputs: Roadmap_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Roadmap konnte nicht exportiert werden. Versuch es noch einmal.`)
};

/**
* | output |
* | --- |
* | "Could not export the roadmap. Try again." |
*
* @param {Roadmap_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const roadmap_failed = /** @type {((inputs?: Roadmap_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Roadmap_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_roadmap_failed(inputs)
	return en_roadmap_failed(inputs)
});